module.exports = __webpack_public_path__ + "media/src/public/images/mail/pretty/speech_bubble-e0e33303bbef8e687b163711126fc684.png";